import React, { useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { getValue } from "../../utils";
import { ReservationsContext } from "../../context/ReservationsContext";
import { ModalContext } from "../../context/ModalContext";
import moment from "moment";

const ClassReservationRating = ({
  class_reservation_id,
  class_reservation,
  handleCancel,
}) => {
  const [coachStars, setCoachStars] = useState(null);
  const [claseStars, setStars] = useState(null);
  const [comment, setComment] = useState(null);

  const { user } = useContext(AuthContext);
  const { alert } = useContext(ModalContext);
  const { saveRating } = useContext(ReservationsContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (claseStars === null) {
      return alert("Debes agregar estrellas para la clase");
    }
    if (coachStars === null) {
      return alert("Debes agregar estrellas para la coach");
    }
    saveRating({
      class_reservation_id,
      customer_id: user.customer_id,
      class_stars: claseStars,
      coach_stars: coachStars,
      comment,
    });
  };

  const renderInput = () => {
    if (coachStars !== null) {
      return (
        <div className="my-3">
          <label className="mb-2">Agrega un comentario (opcional)</label>
          <textarea
            className="form-control mb-3"
            value={getValue({ comment }, "comment")}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
      );
    }
  };

  const renderButtons = () => {
    if (coachStars !== null) {
      return (
        <div className="row">
          <div className="col-6">
            <button
              type="button"
              onClick={handleCancel}
              className="btn w-100 text-muted"
            >
              Cancelar
            </button>
          </div>
          <div className="col-6">
            <button type="submit" className="btn w-100 btn-primary">
              Calificar
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {class_reservation && (
        <div className="row mb-3">
          <div className="col-12">
            <p className="text-center bold mb-0">
              {class_reservation.single_class.class_type.name}
            </p>
            <p className="text-center text-primary bold mb-0">
              {moment(class_reservation.single_class.class_date)
                .utc()
                .format("DD MMM YYYY HH:mm")}
            </p>
            <p className="text-center mb-0">
              Coach: {class_reservation.single_class.class_instructors
                .filter(({ instructor }) => instructor !== null)
                .map((class_instructor) => (
                  <span key={class_instructor.instructor_id}>
                    {class_instructor.instructor.name}
                  </span>
                ))}
            </p>
          </div>
        </div>
      )}
      <p className="text-center">Elige una calificación para esta clase</p>
      <div className="container-fluid text-center mb-4">
        {new Array(5).fill(1).map((one, index) => (
          <button
            key={`clase-${index + 1}`}
            type="button"
            onClick={() => setStars(index + 1)}
            className={`btn d-inline-block ${
              claseStars > index ? "text-warning" : "text-dark"
            }`}
          >
            <i className="fa fa-star"></i>
          </button>
        ))}
      </div>
      <p className="text-center">Elige una calificación para la coach</p>
      <div className="container-fluid text-center mb-4">
        {new Array(5).fill(1).map((one, index) => (
          <button
            key={`coach-${index + 1}`}
            type="button"
            onClick={() => setCoachStars(index + 1)}
            className={`btn d-inline-block ${
              coachStars > index ? "text-warning" : "text-dark"
            }`}
          >
            <i className="fa fa-star"></i>
          </button>
        ))}
      </div>
      {renderInput()}
      {renderButtons()}
    </form>
  );
};

export default ClassReservationRating;
